// Cross-component signal fired whenever a ledger_transactions write succeeds (add/update/delete,
// from any surface — Quick Add, the Transactions page, bank import, recurring rules, etc.).
// Lets an unrelated component (e.g. a list with its own one-time fetch, not a live listener)
// know it should refresh, without those two components needing a direct relationship.
type Listener = () => void;

const listeners = new Set<Listener>();

export function notifyLedgerChanged(): void {
    listeners.forEach(fn => fn());
}

export function onLedgerChanged(fn: Listener): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
}
